import { fabric } from "fabric";

import { ADDITIONAL_CANVAS_FIELDS } from "../constants/canvasConstants";
import { BackgroundImageFillMode } from "./canvasTypes";

export type ExtendedPolygonObject = fabric.Polygon & {
  [ADDITIONAL_CANVAS_FIELDS.polygonShapeName]: "star" | "arrow";
};
export type ExtendedObject = fabric.Object &
  Partial<{
    [ADDITIONAL_CANVAS_FIELDS.meaning]: "viewport" | "background-image";
    [ADDITIONAL_CANVAS_FIELDS.polygonShapeName]: ExtendedPolygonObject["polygonShapeName"];
    [ADDITIONAL_CANVAS_FIELDS.backgroundImageFillMode]: BackgroundImageFillMode;
  }>;

export class BackgroundImage extends fabric.Image {
  [ADDITIONAL_CANVAS_FIELDS.meaning]: NonNullable<ExtendedObject["meaning"]> = "background-image";
  [ADDITIONAL_CANVAS_FIELDS.backgroundImageFillMode]: NonNullable<ExtendedObject["backgroundImageFillMode"]> = "cover";
}

export class ViewportShape extends fabric.Rect {
  [ADDITIONAL_CANVAS_FIELDS.meaning]: NonNullable<ExtendedObject["meaning"]> = "viewport";
}

export class StarShape extends fabric.Polygon {
  [ADDITIONAL_CANVAS_FIELDS.polygonShapeName]: NonNullable<ExtendedObject["polygonShapeName"]> = "star";
}

export class ArrowShape extends fabric.Polygon {
  [ADDITIONAL_CANVAS_FIELDS.polygonShapeName]: NonNullable<ExtendedObject["polygonShapeName"]> = "arrow";
}
